import moment from 'moment-timezone'
import { masaBerlaku, statusToText, toTitleCase } from './formatter'
import { pdfTemplateWithoutDocument } from '../constants/template'

function arrayOfObjectsToCSV(array) {
  let header = Object.keys(array[0]).join(',') + '\n'
  let body = array
    .map((obj) => {
      return Object.values(obj)
        .map((value) => {
          return `\"${value ?? ''}\"`
        })
        .join(',')
    })
    .join('\n')
  return header + body
}

function saveToLocal(data, fileName) {
  const blob = new Blob([data], { type: 'text/plain' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  link.click()
  URL.revokeObjectURL(link.href)
}

function savePendaftar(data) {
  const data_ = data.map((d) => ({
    'Waktu Registrasi': moment(d.createdAt).format('D MMMM YYYY HH:mm:ss'),
    'Nomor Registrasi': d.registrationNumber,
    Korwil: d?.korwil?.name,
    'Status Pendaftaran': statusToText(d),
    'Nama Lengkap': toTitleCase(d.fullname),
    NIK: d.nik,
    Umur: d.birthDate ? moment().diff(d.birthDate, 'years') : '-',
    'Ukuran Kaos': d.shirtSize,
    Email: d.email,
    'Nomor Telepon': d.phoneNumber,
    'Tipe Pendaftaran': d.type,
    'Alamat Lengkap': d.address,
    Kelurahan: d.subdistrict,
    Kecamatan: d.district,
    'Kota/Kabupaten': d.city,
    Provinsi: d.province,
    // 'PDF Pendaftaran': '',
    'Foto DIri': d?.profileImage,
    // 'File KTP': d?.ktpImage?.url,
    'KTA Lama': d?.oldKtaNumber ?? d?.ktaNumber,
    // 'Nomor KTA': d?.user?.ktaNumber,
    // 'Masa Berlaku': masaBerlaku(d),
  }))
  const csv = arrayOfObjectsToCSV(data_)
  saveToLocal(csv, 'Pendaftar.csv')
}

function saveAnggotaAKtif(data) {
  const data_ = data.map((d) => ({
    'Nama Lengkap': toTitleCase(d.fullname),
    'Nomor KTA': d.ktaNumber,
    'Waktu Mulai': moment(d.validAt).tz('Asia/Jakarta').format('D MMM YYYY'),
    'Waktu Berhenti': moment(d.expiredAt)
      .tz('Asia/Jakarta')
      .format('D MMM YYYY'),
    Terkoneksi: !!d.user ? 'Ya' : 'Tidak',
    Username: d?.user?.username,
    Korwil: d?.korwil?.name,
  }))
  const csv = arrayOfObjectsToCSV(data_)
  saveToLocal(csv, 'AnggotaAktif.csv')
}

function generateHtmlDocument({ data }) {
  return pdfTemplateWithoutDocument(data)
}

export {
  arrayOfObjectsToCSV,
  saveToLocal,
  generateHtmlDocument,
  savePendaftar,
  saveAnggotaAKtif,
}
